"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var index_1 = require("../PropProvider/index");

var Flexy_1 = require("./Flexy");

var utils_1 = require("./utils");

Flexy_1.default.Block = index_1.propConnect(utils_1.COMPONENT_KEY.Block)(Flexy_1.default.Block);
Flexy_1.default.Item = index_1.propConnect(utils_1.COMPONENT_KEY.Item)(Flexy_1.default.Item);
exports.default = index_1.propConnect(utils_1.COMPONENT_KEY.Flexy)(Flexy_1.default);